import { IDichVuThongTin } from "../../../model/respone/dich-vu/IDichVuThongTin";
import { IDichVuThongTinActionTypes } from "../../action-types/dich-vu/IDichVuThongTinActions";
import { IDichVuThongTinReducer } from "../../reducer-model/dich-vu/IDichVuThongTinReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
const iniState: IDichVuThongTinReducer = {
  status: eReducerStatusBase.is_not_initialization,
  dichVuThongTins: [],
  idSelections: [],
  dichVuSelection: {} as IDichVuThongTin,
};
export const dichVuThongTinReducer = (
  state: IDichVuThongTinReducer = iniState,
  action: IDichVuThongTinActionTypes
): IDichVuThongTinReducer => {
  switch (action.type) {
    case "DICH_VU_THONG_TIN_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
        idSelections: [],
      };
    case "DICH_VU_THONG_TIN_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        dichVuThongTins: action.payload,
      };
    case "DICH_VU_THONG_TIN_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "DICH_VU_THONG_TIN_SAVE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "DICH_VU_THONG_TIN_SAVE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowEditModal: false,
      };
    case "DICH_VU_THONG_TIN_SAVE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "DICH_VU_THONG_TIN_DELETE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting,
      };
    case "DICH_VU_THONG_TIN_DELETE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
      };
    case "DICH_VU_THONG_TIN_DELETE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "DICH_VU_THONG_TIN_SHOW_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: true,
        dichVuThongTinEditing: action.payload,
      };
    case "DICH_VU_THONG_TIN_CLOSE_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: false,
        dichVuThongTinEditing: undefined,
      };
    case "DICH_VU_THONG_TIN_SELECTED_ID":
      return {
        ...state,
        idSelections: action.payload,
      };
    case "DICH_VU_THONG_TIN_SELECTED_START":
      return {
        ...state,
        dichVuSelection: action.payload,
      };
    default:
      return state;
  }
};
